export default __webpack_public_path__ + "static/media/Group 1722@2x.c5e2068e.png";